import pull from 'lodash/pull'
import indexOf from 'lodash/indexOf'
import forEach from 'lodash/forEach'

// Request animation Singleton
class RAF {
    constructor() {
        this.requestAnimationID = null
        this.funcs = []

        this.start()
    }

    /**
     * Process method of RAF
     */
    process = () => {
        forEach(this.funcs, func => {
            func && func()
        })

        this.requestAnimationID = window.requestAnimationFrame(this.process)
    }

    /**
     * Start RAF
     */
    start = () => {
        if (this.requestAnimationID === null) {
            this.process()
        }
    }

    /**
     * Add function to RAF and start RAF if needed
     * @param func
     */
    add = func => {
        let index = indexOf(this.funcs, func)
        if (index !== -1) return

        this.funcs.push(func)
        if (this.funcs.length > 0) {
            this.start()
        }
    }

    /**
     * Remove function to RAF and stop RAF if needed
     * @param func
     */
    remove = func => {
        this.funcs = pull(this.funcs, func)
        if (this.funcs.length === 0) {
            this.stop()
        }
    }

    /**
     * Stop RAF
     */
    stop = () => {
        if (this.requestAnimationID) {
            window.cancelAnimationFrame(this.requestAnimationID)
            this.requestAnimationID = null
        }
    }
}
const raf = new RAF()
export default raf


// WEBPACK FOOTER //
// ./src/utils/raf.js